{
  "name": "experian-logon-portal",
  "version": "2.1.0",
  "scripts": {
    "prepare": "npx husky install",
    "ng": "ng",
    "start": "ng serve",
    "start:mock": "ng serve --configuration=mock",
    "start:stg": "ng serve --configuration=dev",
    "build": "ng build --aot --output-hashing=all",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test --code-coverage",
    "test:local": "ng test --code-coverage --karma-config=karma.conf-local.js  --browsers=Chrome_without_background_throttle",
    "test:deploy": "ng test --code-coverage --no-watch --browsers=ChromeHeadless",
    "generate:changelog": "conventional-changelog -p angular -i CHANGELOG.md -s -r 0",
    "release:minor": "standard-version --release-as minor  && exit 0",
    "release:patch": "standard-version --release-as patch  && exit 0",
    "release:major": "standard-version --release-as major  && exit 0",
    "lint": "npm run ng lint",
    "_precommit": "npm run release:patch",
    "commit": "git add -A . && npx git-cz",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc:serve": "compodoc -s",
    "mock:start": "node ./mocks/server.js",
    "_preinstall": "npx npm-force-resolutions@0.0.10",
    "biome:format": "biome format --write ."
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.31",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.31",
    "@angular/compiler": "^20.3.31",
    "@angular/core": "^20.3.31",
    "@angular/forms": "^20.3.31",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.31",
    "@angular/platform-browser-dynamic": "^20.3.31",
    "@angular/router": "^20.3.31",
    "@auth0/angular-jwt": "^5.1.2",
    "@datadog/browser-rum": "^6.18.1",
    "@ngneat/cashew": "^4.1.0",
    "experian-change-app-components": "1.2.3",
    "experian-design-system-themes": "^3.0.1",
    "experian-renew-frontend-components": "^1.1.2",
    "material-icons": "^1.13.2",
    "ngx-countdown": "^15.0.0",
    "ngx-guided-tour": "^2.0.1",
    "ngx-mask": "^19.0.6",
    "rxjs": "^7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.37",
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/cli": "^20.3.37",
    "@angular/compiler-cli": "^20.3.31",
    "@biomejs/biome": "1.7.3",
    "@commitlint/cli": "^17.4.2",
    "@commitlint/config-conventional": "^17.4.2",
    "@compodoc/compodoc": "^1.1.21",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@ngrx/store-devtools": "^20.1.0",
    "@types/jasmine": "^2.6.4",
    "@types/node": "22.19.1",
    "@typescript-eslint/eslint-plugin": "^8.70.0",
    "@typescript-eslint/parser": "^8.70.0",
    "commitizen": "^4.3.0",
    "cz-conventional-changelog": "^3.3.0",
    "eslint": "^8.57.1",
    "eslint-plugin-ngrx": "^2.0.0",
    "husky": "^6.0.0",
    "jasmine-core": "^5.5.0",
    "json-server": "^0.17.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "standard-version": "^9.1.0",
    "typescript": "~5.9.3"
  },
  "resolutions": {
    "tough-cookie": "4.1.3",
    "word-wrap": "1.2.5",
    "cross-spawn": "7.0.6"
  },
  "overrides": {
    "@types/node": "22.19.1",
    "@typescript-eslint/types": "8.48.1"
  },
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-conventional-changelog"
    }
  }
}
